import { motion } from "framer-motion";
import { BiX } from "react-icons/bi";
import { useRef, useEffect, useState } from "react";

interface BadgeProps {
  text: string;
  onRemove: () => void;
  color?: string;
  hoverColor?: string;
  disabled?: boolean;
}

const Badge = ({ text, onRemove, color, hoverColor, disabled }: BadgeProps) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const spanRef = useRef<HTMLSpanElement>(null);
  
  useEffect(() => {
    const checkOverflow = () => {
      const span = spanRef.current;
      if (span) {
        // Check if content is overflowing
        setIsOverflowing(
          span.scrollHeight > span.clientHeight || 
          span.scrollWidth > span.clientWidth
        );
      }
    };
    
    checkOverflow();
    // Re-check on window resize
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [text]);

  return (
    <motion.div 
      className={`badge ${isOverflowing ? 'text-overflow' : ''}`}
      style={{
        backgroundColor: color,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.7 : 1
      }}
      whileHover={hoverColor ? { backgroundColor: hoverColor } : {}}
      data-tooltip={text}>
      <span ref={spanRef}>
        {text}
      </span>
      <BiX size={20} onClick={() => {
        if (!disabled) {
          onRemove();
        }
      }} className="clickable" />
    </motion.div>
  );
}

export default Badge;